import { render, staticRenderFns } from "./pingbi.vue?vue&type=template&id=2fbe8fa0"
import script from "./pingbi.vue?vue&type=script&lang=js"
export * from "./pingbi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports